import { createAction } from '@reduxjs/toolkit';

export const createTab = createAction('CREATE_TAB');
export const updateTab = createAction('UPDATE_TAB');
export const closeTab = createAction('CLOSE_TAB');
export const clearTabs = createAction('CLEAR_TABS');
export const toggleChat = createAction('TOGGLE_CHAT');
export const sendWelcomeMessage = createAction('SEND_WELCOME_MESSAGE');
export const clearWelcomeMessage = createAction('CLEAR_WELCOME_MESSAGE');
